import InputField from "components/common/controls/InputField";
import FormGroup from "components/common/FormGroup";
import { EditorMode } from "shared/enums/EditorModeEnum";
import { connect } from "react-redux";
import Checkbox from "components/common/controls/Checkbox";
import UserResponse from "interfaces/response/UserResponse";
import Button from "components/common/controls/NewButton";
import CreateStripeCustomer from "./CreateStripeCustomerConfirmationDialog";
import { createStripeCustomerForSelectedUserAsync } from "store/slices/UserManagementSlice";
import { AppDispatch } from "store/store";
import { Component } from "react";
import { unwrapResult } from "@reduxjs/toolkit";
import React from "react";
import StripeCustomerResponse from "interfaces/response/StripeCustomerResponse";

interface Props {
  dispatch: AppDispatch;
  user?: UserResponse;
  mode: EditorMode;
  handleChange: (value: any, fieldName: string) => void;
}

interface State {
  isCreateStripePopupVisible: boolean;
  customerIdFIeldValue?: string;
}

export class StripeCustomerEditor extends Component<Props, State> {
  createStripeCustomerTag = "createStripeCustomer";
  stripeCustomerIdTag = "customerId";
  isInEditMode = this.props.mode === EditorMode.Edit;
  showStripeCustomerAddButton = !(this.props.user?.isRegisteredOnStripe);
  
  stripeCustomerRef = React.createRef<any>();

  state: Readonly<State> = {
    isCreateStripePopupVisible: false,
    customerIdFIeldValue: this.showStripeCustomerAddButton ? "" : this.props.user?.customerId,
  };

  handleCreateStriperCustomer = () => {
    this.setState({ isCreateStripePopupVisible: true });
  }
  handleCreateStripePopupClose = () => {
    this.setState({ isCreateStripePopupVisible: false });
  }
  
  componentDidUpdate(prevProps: any) {
    if(prevProps.user !== this.props.user) {
      this.showStripeCustomerAddButton = !(this.props.user?.isRegisteredOnStripe);
      this.setState({ customerIdFIeldValue: this.showStripeCustomerAddButton ? "" : this.props.user?.customerId });
    }
  }

  handleConfirm = () => {
    this.props.dispatch(createStripeCustomerForSelectedUserAsync({
      userId: this.props.user?.id
    }))
    .then(unwrapResult)
    .then((response: StripeCustomerResponse) => {
      this.setState({ isCreateStripePopupVisible: false, customerIdFIeldValue: response.customerId });
      this.props.handleChange(response.customerId, this.stripeCustomerIdTag);
    })
  };

  render() {
    return (
      <>
        {this.isInEditMode
          ? (<>
              <FormGroup label="Stripe Customer Id" >
                <InputField
                  name="customerId"
                  value={this.state.customerIdFIeldValue}
                  id="customerId"
                  disabled={this.showStripeCustomerAddButton}
                  label="Stripe Customer Id"
                  className="w-40"
                  onChange={(e : any) => {
                    this.setState({customerIdFIeldValue: e.event.target.value});
                    this.props.handleChange(e.event.target.value, e.event.target.name);
                  }}
                />
              </FormGroup>
              <div className="mt-8 ml-8">
                {this.showStripeCustomerAddButton && 
                  (
                    <Button
                      responsive={false}
                      text={"Add"}
                      onClick={this.handleCreateStriperCustomer}
                      key="grid-new-button"
                    />
                  )
                }  
              </div>
            </>)
          : (<FormGroup label="Create Striper Customer">
              <Checkbox
                className="w-28"
                name="createStripeCustomer"
                text="Yes"
                label="Yes"
                defaultValue={true}
                onValueChange={(e : any) => {
                  this.props.handleChange(e, this.createStripeCustomerTag);
                }}
              />
            </FormGroup>)
          }
        {this.state.isCreateStripePopupVisible && (
          <CreateStripeCustomer
            onClose={this.handleCreateStripePopupClose}
            handleConfirm={this.handleConfirm}
          />
        )}
      </>
    );
  }
}

export default connect()(StripeCustomerEditor);
